<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">出入记录列表</h3>

        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-sm-12 col-md-4 text-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnInOut"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">出入记录</p>
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:80px;"
                        @click="getList('CREATE_TIME',$event)"
                      >时间</th>
                      <th
                        class="text-left sorting d-md-table-cell"
                        style="min-width:110px;"
                        @click="getList('CARPORT_NAME',$event)"
                      >车棚名称</th>
                      <th
                        class="text-left sorting d-md-table-cell"
                        style="min-width:110px;"
                        @click="getList('CARPORT_NAME',$event)"
                      >门闸名称</th>
                      <th
                        class="text-left sorting d-md-table-cell"
                        style="min-width:110px;"
                        @click="getList('IN_TYPE',$event)"
                      >进出方式</th>
                      <!-- <th
                          class="text-left sorting"
                          style="min-width:110px;"
                          @click="getList('AREA',$event)"
                        >所在区域</th>
                        <th
                          class="text-left d-xl-table-cell sorting"
                          style="min-width:80px;"
                          @click="getList('IN_USER_ID',$event)"
                        >用户ID</th>
                        <th
                          class="text-left d-xl-table-cell sorting"
                          style="min-width:80px;"
                          @click="getList('CARD_NO',$event)"
                        >实体卡号</th>
                        <th
                          class="text-left d-xl-table-cell sorting"
                          style="min-width:80px;"
                          @click="getList('MOBILE_PHONE',$event)"
                      >手机号码</th>-->

                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="width: 150px; min-width:150px"
                        @click="getList('ID',$event)"
                      >进出记录</th>
                    </tr>
                  </thead>
                  <tbody v-if="agents.length">
                    <tr v-for="(agent, i) in agents" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left d-xl-table-cell">{{ agent.CREATE_TIME}}</td>
                      <td class="text-left d-md-table-cell">{{ agent.CARPORT_NAME }}</td>
                      <td class="text-left d-md-table-cell">{{ agent.ENTRANCE_GUARD_NAME }}</td>
                      <td class="text-left d-md-table-cell">{{ showInType(agent.IN_TYPE) }}</td>
                      <!-- <td class="text-left">{{ agent.AREA }}</td>
                        <td class="text-left d-xl-table-cell">{{ agent.IN_USER_ID }}</td>
                        <td class="text-left d-xl-table-cell">{{ agent.CARD_NO}}</td>
                      <td class="text-left d-xl-table-cell">{{ agent.MOBILE_PHONE}}</td>-->

                      <td class="text-center d-xl-table-cell">
                        <span
                          class="badge badge-pill"
                          :class="{'badge-success':agent.IN_OUT  =='1','badge-secondary':agent.IN_OUT  =='2'}"
                        >{{ showInOutType(agent.IN_OUT ) }}</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="8">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="agents && agents.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import Util from "../../../../Util.js";
import pageSize from "../../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      state: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      created: false,
      form: {
        id: "",
        status: ""
      },
      statusList: [
        {
          value: "1",
          label: "启用"
        },
        {
          value: "2",
          label: "禁用"
        },
        {
          value: "3",
          label: "故障"
        }
      ],
      sorting: "",
      orderBy: false
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    // this.getEntry()
    this.getList();
    this.copy();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    showInType(str) {
      switch (str) {
        case "1":
          return "刷卡";
        case "2":
          return "人脸识别";
        case "3":
          return "RFID设备";
        case "4":
          return "扫码";
      }
    },
    showInOutType(str) {
      switch (str) {
        case "1":
          return "已入场";
        case "2":
          return "已出场";
      }
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }
      if (this.state != "") {
        params["state"] = this.state;
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/User/GetUserStopList/${this.$route.params.id}/${this.page}/${this.pageSize}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/User/GetUserStopList/${this.$route.params.id}/${this.page}/${this.pageSize}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr;
      if (this.$route.name == "carportWhiteUser") {
        copyStr = document.getElementsByTagName("section")[4].innerText;
      }
      var btn = document.getElementById("copybtnInOut");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    }
  }
};
</script>